const homeScreenButtonText = {
  INITIATE_VIDEO_CALL: 'Join Session',
  INITIATE_AUDIO_CALL: `Call Member`,
  REJOIN_AUDIO_CALL: 'Redial',
  REJOIN_VIDEO_CALL: 'Continue Session',
  COMPLETE_SESSION_NOTES: 'Complete Session Notes',
  START_SESSION: 'START SESSION',
};

export { homeScreenButtonText };
